import React, { useEffect, useState } from 'react';
import './HintButton.css';

const HintButton = ({ level, onRevealHint, hints, isDarkMode, hintStatus }) => {
  const [revealedHints, setRevealedHints] = useState({
    year: hintStatus.year,
    genre: hintStatus.genre,
    director: hintStatus.director,
    mainActor: hintStatus.mainActor,
  });

  // Synchronize revealedHints with hintStatus when hintStatus changes
  useEffect(() => {
    setRevealedHints({
      year: hintStatus.year,
      genre: hintStatus.genre,
      director: hintStatus.director,
      mainActor: hintStatus.mainActor,
    });
  }, [hintStatus]);

  const handleClick = (hint) => {
    if (!revealedHints[hint]) {
      setRevealedHints({ ...revealedHints, [hint]: true });
      onRevealHint(level, hint);
    }
  };

  return (
    <div className="hint-container">
      <button
        className={`hint-button ${isDarkMode ? 'dark-mode' : ''} enabled`}
        onClick={() => handleClick('year')}
      >
        <span>🗓️</span> {revealedHints.year && <span className="hint-text">{hints.year}</span>}
      </button>
      <button
        className={`hint-button ${isDarkMode ? 'dark-mode' : ''} enabled`}
        onClick={() => handleClick('genre')}
      >
        <span>🎭</span> {revealedHints.genre && <span className="hint-text">{hints.genre}</span>}
      </button>
      <button
        className={`hint-button ${isDarkMode ? 'dark-mode' : ''} enabled`}
        onClick={() => handleClick('director')}
      >
        <span>🎬</span> {revealedHints.director && <span className="hint-text">{hints.director}</span>}
      </button>
      <button
        className={`hint-button ${isDarkMode ? 'dark-mode' : ''} enabled`}
        onClick={() => handleClick('mainActor')}
      >
        <span>🌟</span> {revealedHints.mainActor && <span className="hint-text">{hints.mainActor}</span>}
      </button>
    </div>
  );
};

export default HintButton;